import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/14f4fbac45432f7878a86a5e6cf37f7a.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative z-10 text-center w-full max-w-3xl mx-auto px-6">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-300 mb-5">
          Bordeaux, France
        </p>
        <h1 className="font-poppins text-5xl lg:text-6xl font-light text-white leading-tight tracking-wide mb-6">
          Conseil en affaires
          <br />
          <span className="font-semibold">et gestion</span>
        </h1>
        <p className="text-gray-200 text-base lg:text-lg leading-relaxed max-w-xl mx-auto mb-10">
          SOMINKA accompagne les entrepreneurs et les entreprises dans le développement
          et l'optimisation de leur activité. Des solutions claires, efficaces et adaptées.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="px-8 py-3.5 rounded-full bg-white text-[#1A2B4A] font-medium text-sm hover:bg-gray-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Contactez-nous
          </Link>
          <Link
            to="/a-propos"
            className="px-8 py-3.5 rounded-full border border-white/60 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            En savoir plus
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Découvrir</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
}
